<template lang="jade">
.p_section.col-md-12.col-sm-12.row_space--xs.no_pad-xxs.clearfix
  .btn-group
    button.btn.btn-default.arrow(@click.prevent="setPage(currPage-1)" v-bind:class="{'disabled': (currPage === 1)}")
      span.glyphicon.glyphicon-chevron-left
    button.btn.btn-default.more(@click='setPaginationSec(currPaginationSec-1)' v-if='currPaginationSec !== 1')  ...
    button.btn.btn-default.page(@click.prevent="setPage(n+1)" v-for="n in totalPageAry | limitBy countOfPagination paginationStart" v-bind:class="{'active': (currPage === (n+1))}" )  {{n+1}}
    button.btn.btn-default.more(@click='setPaginationSec(currPaginationSec+1)' v-if='currPaginationSec !== totalSection')  ...
    button.btn.btn-default.arrow(@click.prevent="setPage(currPage+1)" v-bind:class="{'disabled': (currPage === totalPage)}")
      span.glyphicon.glyphicon-chevron-right
</template>
<script>
export default {
  components: {
  },
  data () {
    return {
      countOfPage: 50,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1
    }
  },
  computed: {
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    },
    paginationStart () {
      return (this.currPaginationSec - 1) * this.countOfPagination
    },
    totalSection () {
      return Math.ceil(this.totalPage / this.countOfPagination)
    },
    totalPage () {
      return Math.ceil(this.computedLog.length / this.countOfPage)
    },
    totalPageAry () {
      let ary = []
      for (let i = 0; i < this.totalPage; i++) {
        ary.push(i)
      }
      return ary
    }
  },
  methods: {
    setPage: function (idx) {
      if (idx <= 0 || idx > this.totalPage) {
        return
      }
      this.currPage = idx
      if (idx > this.currPaginationSec * this.countOfPagination) {
        this.setPaginationSec(this.currPaginationSec + 1)
      } else if (idx <= (this.currPaginationSec - 1) * this.countOfPagination) {
        this.setPaginationSec(this.currPaginationSec - 1)
      }
    },
    setPaginationSec (idx) {
      if (idx <= 0 || idx > this.totalSection) {
        return
      }
      this.currPaginationSec = idx
    }
  }, // close methods
  ready () {
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';

</style>



// WEBPACK FOOTER //
// Pagination.vue?ed0c85b4